class Usuario{
    constructor(id, nombre, denominacion, tipo, estado){
        this.id = id;
        this.nombre = nombre;
        this.denominacion = denominacion;
        this.tipo = tipo;
        this.estado = estado;
    }
}
export default Usuario;
